import {ListEmptySearch} from '@sollapay/ui/components';
import {Trans, useTranslation} from 'react-i18next';

import type {FC} from 'react';

/** With no search text, the empty result comes from the filters, so the action clears those instead. */
export interface TrustAccountListEmptySearchProps {
  searchText: string;
  onClearSearch: () => void;
  onClearFilters: () => void;
}

export const TrustAccountListEmptySearch: FC<TrustAccountListEmptySearchProps> = ({
  searchText,
  onClearSearch,
  onClearFilters
}) => {
  const {t} = useTranslation('trustAccounts');
  const isFilterOnly = !searchText;

  return (
    <ListEmptySearch
      title={t('search.emptyTitle')}
      subtitle={
        isFilterOnly ? (
          <Trans t={t} i18nKey="search.emptySubtitleFiltered" components={{br: <br />}} />
        ) : (
          <Trans
            t={t}
            i18nKey="search.emptySubtitle"
            values={{term: searchText}}
            components={{bold: <strong className="font-semibold text-fg-secondary" />, br: <br />}}
          />
        )
      }
      clearLabel={isFilterOnly ? t('search.clearFilters') : t('search.clearSearch')}
      onClear={isFilterOnly ? onClearFilters : onClearSearch}
    />
  );
};
